/* src/app/rating/rating-finished/rating-finished.component.scss */
.rating {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 22px;
}
.rating:last-child {
  border-bottom: none;
}
.rating.header .rating-col {
  font-size: 20px;
  display: flex;
  flex-direction: column;
}
.rating.header .rating-col .rating-type {
  color: #6DCC09;
}
h1 {
  font-size: 2.4rem;
}
h1.question-text {
  font-size: 1.7rem;
  margin-bottom: 10px;
}
h1.question-text:nth-child(1) {
  margin-top: 100px;
}
p {
  font-size: 20px;
}
.rating-col:first-child {
  flex: 1.3;
}
.rating-col {
  flex: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}
.rating-col img {
  width: 280px;
}
div.text-center {
  margin: 0 auto;
  max-width: 800px;
}
div.text-center p {
  margin: 20px 0 40px 0;
}
div.text-center button.active {
  margin-right: 16px;
}
#finishedD {
  float: right;
  margin-bottom: 50px;
}
/*# sourceMappingURL=rating-finished.component.css.map */
